import { IStateColours } from "@types"
import { protectedApi } from "store/Api"

const settingsStateColour = protectedApi.injectEndpoints({


    endpoints: (builder) => ({
        settingsStateColour: builder.query<IStateColours[], void>({
            query: () => {
                return {
                    method: "GET",
                    url: `settings/state_colours`,
                }
            },
        }),
    }),
})

export const { useSettingsStateColourQuery } = settingsStateColour
